<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose">
        <div class="row">
            <div class="col-12">
                Estado: {{ form.state_type_name }}
                <x-button-primary
                    v-if="form.btn_state_type"
                    @click="updateState"></x-button-primary>
            </div>
            <div class="col-12">
                Usuario: {{ form.user_name }}
            </div>
            <div class="col-12">
                Descargas:
                <x-button-download :resource="resource"
                                   :external-id="form.external_id"
                                   :filename="form.filename"
                                   text="PDF"
                                   type="pdf"></x-button-download>
            </div>
            <div class="col-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../../components/Form/XButtonSubmit";
import XModal from "../../../../../components/XModal";
import XButtonIcon from "../../../../../components/Form/XButtonIcon.vue";
import XButtonPrimary from "../../../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../../../components/Form/XButtonDownload.vue";

export default {
    name: 'InventoryGuideInformation',
    components: {XButtonDownload, XButtonPrimary, XButtonIcon, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        resource: {
            type: String,
            required: true,
        },
        recordId: {
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            title: null,
            form: {}
        }
    },
    methods: {
        initForm() {
            this.title = '';
            this.form = {}
        },
        async initRecord() {
            this.loading = true
            await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                .then(response => {
                    this.form = Object.assign({}, this.form, response.data.data);
                });
            this.title = this.form.title;
            this.loading = false
        },
        async handleOpen() {
            this.initForm();
            await this.initRecord();
        },
        async updateState() {
            await this.$http.post(`/${this.resource}/update_state`, {
                'id': this.form.id
            })
                .then(response => {
                    this.$message.success(response.data.message)
                    this.initRecord();
                    this.$emit('success-state-type')
                });
        },
        clickClose() {
            this.$emit('update:showDialog', false)
            this.initForm()
        },
    }
}
</script>
